import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("working"); // working | ok | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = params.get("token") || "";
    if (!token) { setState("error"); setMessage("Missing token — request a new link from your profile."); return; }
    api.post("/auth/verify-email", { token }).then((r) => {
      setState("ok");
      setMessage(`Linked ${r.data.email}. You can now reset your password by email.`);
      if (typeof refresh === "function") refresh();
      toast.success("Email confirmed.");
      setTimeout(() => nav("/profile"), 2500);
    }).catch((e) => {
      setState("error");
      setMessage(e.response?.data?.detail || "Verification failed.");
    });
  }, [params, refresh, nav]);

  return (
    <div className="max-w-md mx-auto py-16 text-center" data-testid="verify-root">
      {state === "working" && <div className="text-gray-400 font-mono uppercase tracking-widest text-xs">Confirming…</div>}
      {state === "ok" && (
        <div data-testid="verify-ok" className="border border-emerald-400/40 bg-emerald-400/5 p-6 space-y-3">
          <CheckCircle2 className="w-8 h-8 text-emerald-400 mx-auto" />
          <div className="text-emerald-400 font-mono uppercase tracking-widest text-xs font-bold">Email confirmed</div>
          <div className="text-sm text-gray-300">{message}</div>
        </div>
      )}
      {state === "error" && (
        <div data-testid="verify-error" className="border border-red-500/40 bg-red-500/5 p-6 space-y-3">
          <XCircle className="w-8 h-8 text-red-500 mx-auto" />
          <div className="text-red-500 font-mono uppercase tracking-widest text-xs font-bold">Confirmation failed</div>
          <div className="text-sm text-gray-300">{message}</div>
        </div>
      )}
    </div>
  );
}
